"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashflowImpressionsList = void 0;
const React = require("react");
const hi_1 = require("react-icons/hi");
const im_1 = require("react-icons/im");
const md_1 = require("react-icons/md");
const general_impression_config_1 = require("../config/general-impression.config");
exports.cashflowImpressionsList = [
    {
        id: 0,
        title: 'FCO',
        subtitle: 'Muito bom',
        description: 'A longo prazo, foi detectado que a empresa consegue manter os números de caixa operacional crescendo a cada demonstração, é um bom sinal.',
        icon: React.createElement(hi_1.HiPresentationChartLine, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 79,
        reportableIdentification: 'FCO_MUITO_BOM',
    },
    {
        id: 1,
        title: 'Visionária',
        subtitle: 'Buffet?!',
        description: 'Foi detectado que a empresa realiza diversos investimentos, isso indica que a empresa visa crescimento a longo prazo.',
        icon: React.createElement(im_1.ImEyePlus, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 80,
        reportableIdentification: 'EMPRESA_VISIONARIA',
    },
    {
        id: 2,
        title: 'Bom Caixa',
        subtitle: 'Cashieer!',
        description: 'Foi detectado que a empresa tem um bom gerenciamento do fluxo de caixa e consegue manter em harmonia os números de suas entradas e saídas de caixa a longo prazo.',
        icon: React.createElement(hi_1.HiOutlineCash, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.nice,
        importantLevel: 85,
        reportableIdentification: 'BOM_CAIXA',
    },
    {
        id: 3,
        title: 'Fluxo de Caixa',
        subtitle: 'Caindo',
        description: 'Foi detectado que a empresa está com seu fluxo de entradas no caixa cada vez mais baixo em cada demonstração.',
        icon: React.createElement(hi_1.HiOutlineCash, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 85,
        reportableIdentification: 'FLUXO_CAIXA_CAINDO',
    },
    {
        id: 4,
        title: 'Fluxo de Caixa',
        subtitle: 'PROBLEMÁTICO',
        description: 'Foi detectado que a empresa está com problemas no seu fluxo de caixa, onde as saídas no caixa estão mais altas que as entradas, tenha cuidado.',
        icon: React.createElement(md_1.MdMoneyOffCsred, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'FLUXO_CAIXA_PROBLEMATICO',
    },
    {
        id: 5,
        title: 'FCO',
        subtitle: 'Ruim',
        description: 'Foi detectado que os números do caixa operacional dessa empresa estão caindo a cada ano que se passa.',
        icon: React.createElement(md_1.MdStackedBarChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 85,
        reportableIdentification: 'FCO_RUIM',
    },
];
//# sourceMappingURL=cashflow-impressions.data.js.map